/**
 * Renders the Bifrost Detail Component.
 *
 * @param {Object} chosenOrg - The chosen organization object.
 * @returns {JSX.Element} The rendered Bifrost Detail Component.
 */
import React from "react"
// import Loader from "../../Loader/Loader";
import { useAuth0 } from "@auth0/auth0-react"
import { Label } from "semantic-ui-react"
import RenameDeviceModal from "../../../../Pages/MainPanel/MainPanelBody/DevicesPage/DeviceDetailsPage/RenameDeviceModal/RenameDeviceModal"
import UpgradeFirmwareModal from "../../../../Pages/MainPanel/MainPanelBody/DevicesPage/DeviceDetailsPage/UpgradeFirmwareModal/UpgradeFirmwareModal"
import { isSuperAdminOrResellerAdmin } from "../../../../Utils/util"
import BifrostSegment from "../../../BifrostElementComponent/BifrostSegment/BifrostSegment"
import TransferDeviceToOrgModal from "../../../TransferDeviceToOrgModal/template/TransferDeviceToOrgModal"

const DeviceDetailsSegment = ({ data, getDeviceById, latestFirmwareVersion, firmwareUpToDate }) => {
	const { user } = useAuth0()

	const segmentList = [
		[
			{
				key: "name",
				feedName: "Device Name",
				content: {
					modal: <RenameDeviceModal data={data} getDeviceById={getDeviceById} disabled={data.state !== "idle"} />
				}
			},
			{
				key: "serialnr",
				feedName: "Serial Number",
				content: {
					label: data.serialnr,
					className: "device-change-disabled"
				}
			},
			{
				key: "type",
				feedName: "Type",
				content: {
					label: data.type,
					className: "device-change-disabled"
				}
			},
			{
				key: "org",
				feedName: "Organization",
				renderCondition: isSuperAdminOrResellerAdmin(user),
				content: {
					label: data.org_name ? data.org_name : "Unknown",
					className: "device-change-disabled"
				}
			},
			{
				key: "groups",
				feedName: "Groups",
				content: {
					label: data.groups && data.groups.length > 0 ? data.groups.map((group) => <div key={group.id}>{group.name}</div>) : "None"
				}
			}
			// Add a button to move device to another organization
		],
		[
			{
				key: "firmwareVersion",
				feedName: "Firmware Version",
				content: {
					label: data.firmware ? (
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div className="device-detail-cell">
								{data.firmware.toString()}
								{latestFirmwareVersion && firmwareUpToDate && (
									<Label style={{ marginLeft: "10px" }} size="small">
										LATEST
									</Label>
								)}
							</div>
							{latestFirmwareVersion && (
								<div style={{ display: "flex", position: "relative" }}>
									<UpgradeFirmwareModal disabled={data.state !== "idle"} device={data} latestFirmwareVersion={latestFirmwareVersion} firmwareUpToDate={firmwareUpToDate} />
								</div>
							)}
						</div>
					) : (
						"Unknown"
					)
				}
			},
			{
				key: "lastHeartbeat",
				feedName: "Last Heartbeat",
				content: { label: data.timestamp ? data.timestamp : "Unknown" }
			},
			{
				key: "lastSession",
				feedName: "Last Session",
				content: { label: data.last_session ? data.last_session : "Unknown" }
			},
			{
				key: "transferD2O",
				feedName: "Transfer Device to another Organization",
				renderCondition: isSuperAdminOrResellerAdmin(user),
				content: {
					label: <TransferDeviceToOrgModal type="device" refresh={getDeviceById} device={data} />
				}
			}
		]
	]

	return <BifrostSegment segmentList={segmentList} />
}

export default DeviceDetailsSegment
